export { default as consumption } from './consumption.svg';
export { default as attack } from './attack.svg';
export { default as defence } from './defence.svg';
export { default as structure } from './structure.svg';



// WEBPACK FOOTER //
// ./src/components/Obelisk/images/index.js